// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.router-link-exact-active[data-v-6fd0c6b3]{--tw-text-opacity:1;color:rgb(29 29 27 / var(--tw-text-opacity))}a.router-link-exact-active img.inactive-icon[data-v-6fd0c6b3]{display:none}a.router-link-exact-active img.active-icon[data-v-6fd0c6b3]{display:block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
